export const API_BASE_URL = "https://registeration.theeventpics.com/API";
